import React, { useEffect, useState } from 'react';
import { Checkbox, Modal } from '@gerdau/hefesto';
import {
  GmaisModalContent,
  GmaisModalNeverShowAgainContainer,
  ModalOverlay
} from './styles';
import { UserService } from '../../services/User';

export interface IGmaisModalProps {
  onDismissModal: () => void;
  title: string;
  dontShowAgainCheckBox: boolean;
  dontShowThisAgain: () => Promise<void>;
  buttons: {
    action?: {
      title: string;
      callback: () => void;
      disabled?: boolean;
      loading?: boolean;
    };
    close: {
      title: string;
      callback: (neverShowAgain: boolean) => void;
      disabled?: boolean;
      loading?: boolean;
    };
  };
  modalSize?: 'sm' | 'md' | 'lg';
}

export type GmaisModalProps = React.PropsWithChildren<IGmaisModalProps>;

export const GmaisModal = ({
  buttons,
  children,
  title,
  dontShowAgainCheckBox,
  onDismissModal,
  dontShowThisAgain,
  modalSize = 'sm'
}: GmaisModalProps) => {
  const [neverShowInput, setNeverShowInput] = useState<boolean>(false);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'visible';
    };
  }, []);

  async function updateUserIfNeeded(): Promise<void> {
    if (neverShowInput) {
      dontShowThisAgain().then(console.log).catch(console.error);
    }
  }

  async function closeModal() {
    await updateUserIfNeeded();
    buttons.close.callback(neverShowInput);
  }

  async function dismissModal() {
    await updateUserIfNeeded();
    onDismissModal();
  }

  async function actionButton() {
    await updateUserIfNeeded();
    buttons?.action?.callback();
  }

  return (
    <ModalOverlay>
      <Modal
        title={title}
        modalSize={modalSize}
        onClose={dismissModal}
        buttons={
          buttons.action
            ? {
                left: {
                  name: 'button-close-blocked-emitter2',
                  children: buttons.close.title,
                  onClick: closeModal,
                  type: 'submit',
                  loading: buttons.close.loading,
                  disabled: buttons.close.disabled
                },
                right: {
                  name: 'button-close-blocked-emitter',
                  children: buttons.action.title,
                  onClick: actionButton,
                  type: 'button',
                  loading: buttons.action.loading,
                  disabled: buttons.action.disabled
                }
              }
            : {
                right: {
                  name: 'button-close-blocked-emitter2',
                  children: buttons.close.title,
                  onClick: closeModal,
                  type: 'submit',
                  loading: buttons.close.loading,
                  disabled: buttons.close.disabled
                }
              }
        }
      >
        <GmaisModalContent>{children}</GmaisModalContent>
        {dontShowAgainCheckBox && (
          <GmaisModalNeverShowAgainContainer>
            <Checkbox
              name={'Não mostrar novamente'}
              checked={neverShowInput}
              onChange={(e) => setNeverShowInput(e.target.checked)}
              label={'Não exibir novamente'}
            />
          </GmaisModalNeverShowAgainContainer>
        )}
      </Modal>
    </ModalOverlay>
  );
};
